import { render, staticRenderFns } from "./WaybillDownload.vue?vue&type=template&id=530a6561&scoped=true"
import script from "./WaybillDownload.vue?vue&type=script&lang=js"
export * from "./WaybillDownload.vue?vue&type=script&lang=js"
import style0 from "./WaybillDownload.vue?vue&type=style&index=0&id=530a6561&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530a6561",
  null
  
)

export default component.exports